import { Link } from "react-router-dom";
import { Award } from "lucide-react";

const FALLBACK = "https://images.unsplash.com/photo-1644302406498-9ee320a1ec5e?crop=entropy&cs=srgb&fm=jpg&w=900&q=80";

export default function WineCard({ wine, onQuote }) {
    const photo = wine.photos?.[0] || FALLBACK;
    return (
        <article className="card-marketing group mkt-card-lift" data-testid={`wine-card-${wine.id}`}>
            <Link to={`/winery/${wine.winery_slug}`} className="block relative overflow-hidden">
                <div className="aspect-[3/4] overflow-hidden bg-[#0A0A0A]">
                    <img
                        src={photo}
                        alt={wine.name}
                        loading="lazy"
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                </div>
                {wine.score ? (
                    <div className="absolute top-4 left-4 bg-black/70 backdrop-blur-sm border-l-2 border-[#C9A961] px-3 py-1.5 flex items-center gap-1.5">
                        <Award className="w-3 h-3 text-[#C9A961]" strokeWidth={1.5} />
                        <span className="text-[#C9A961] text-xs tracking-[0.15em] uppercase">JS {wine.score}</span>
                    </div>
                ) : null}
            </Link>

            <div className="p-6">
                <p className="overline">{wine.grape} · {wine.vintage}</p>
                <h3 className="font-display text-2xl mt-2 leading-tight">{wine.name}</h3>
                {wine.winery_name && (
                    <Link to={`/winery/${wine.winery_slug}`} className="text-sm text-[#A1A1AA] hover:text-[#C9A961] transition-colors duration-500 block mt-1">
                        {wine.winery_name} · {wine.region}
                    </Link>
                )}

                <div className="flex items-end justify-between mt-6 pt-6 border-t border-[#27272A]">
                    <div>
                        <p className="text-xs text-[#71717A] tracking-[0.15em] uppercase">FOB</p>
                        <p className="font-display text-4xl text-[#C9A961] leading-none mt-1">${wine.price_fob_usd?.toFixed(2)}</p>
                    </div>
                    <div className="flex flex-col items-end gap-2">
                        <button
                            onClick={() => onQuote && onQuote(wine, "quote")}
                            data-testid={`wine-quote-${wine.id}`}
                            className="text-xs tracking-[0.15em] uppercase text-white hover:text-[#C9A961] transition-colors duration-500 border-b border-[#27272A] hover:border-[#C9A961] pb-1"
                        >
                            Request Quote
                        </button>
                        <button
                            onClick={() => onQuote && onQuote(wine, "sample")}
                            data-testid={`wine-sample-${wine.id}`}
                            className="text-xs tracking-[0.15em] uppercase text-[#C9A961] hover:text-white transition-colors duration-500 border-b border-[#C9A961] hover:border-white pb-1"
                        >
                            Request Sample
                        </button>
                        <button
                            onClick={() => onQuote && onQuote(wine, "buy")}
                            data-testid={`wine-buy-${wine.id}`}
                            className="btn-gold hero-cta-glow !py-2 !px-4 !text-[10px] mt-1"
                        >
                            Solicitar Compra →
                        </button>
                        <button
                            onClick={() => onQuote && onQuote(wine, "paynow")}
                            data-testid={`wine-paynow-${wine.id}`}
                            className="text-[10px] tracking-[0.15em] uppercase text-[#C9A961] hover:text-white transition-colors duration-500 border-b border-[#C9A961] hover:border-white pb-0.5 mt-1"
                        >
                            Pagar USD {Math.round(wine.price_fob_usd || 0).toLocaleString("en-US")}
                        </button>
                    </div>
                </div>
                {wine.description && (
                    <p className="text-sm text-[#A1A1AA] italic font-display-italic mt-4 leading-relaxed line-clamp-2" data-testid={`wine-notes-${wine.id}`}>
                        {wine.description}
                    </p>
                )}
                {wine.tech_sheet_pdf_url && (
                    <a
                        href={wine.tech_sheet_pdf_url}
                        target="_blank"
                        rel="noreferrer"
                        className="text-xs text-[#71717A] hover:text-[#C9A961] tracking-[0.15em] uppercase mt-4 inline-block transition-colors duration-500"
                        data-testid={`wine-tech-sheet-${wine.id}`}
                    >
                        Download Tech Sheet ↓
                    </a>
                )}
            </div>
        </article>
    );
}
